import { createApi } from '@reduxjs/toolkit/query/react'

import { baseApi } from './utils'
import { Dashboard } from './types'

export const dashboardApi = createApi({
	reducerPath: 'dashboard',
	...baseApi('/dashboards'),
	tagTypes: ['mp-dash-main', 'mp-dash-vehicle-hire'],
	endpoints: builder => ({
		getVehicleHireDash: builder.query<Dashboard, void>({
			query: () => '/vehicle-hire/',
		}),
	}),
})

export const { useGetVehicleHireDashQuery } = dashboardApi
